<template>
  <div class="chip">
    {{title}}
    <i class="fa fa-times" @click="remove(title)"></i>
  </div>
</template>
<script>
  export default {
    name: 'AddRule',
    props: ['title'],
    data () {
      return {
      }
    },
    methods: {
      remove (title) {
        this.$emit('click', title)
      }
    }
  }
</script>
<style>
  .chip {
    display: inline-block;
    height: 26px;
    font-size: 12px;
    font-weight: 500;
    color: rgba(0,0,0,0.6);
    line-height: 26px;
    border-radius: 16px;
    background-color: #e4e4e4;
    margin-bottom: 5px;
    margin-top: 5px;
    margin-right: 5px;
    padding-left: 10px;
  }
    .chip > i {
      cursor: pointer;
      width: 20px;
      height: 20px;
      padding-left: 5px;
      padding-top: 3.5px;
      margin-right: 2px;
    }
    .chip > i:hover {
      border-radius: 50%;
      background-color: #aaa;
    }
</style>



// WEBPACK FOOTER //
// VAChip.vue?b882893c